import { isNotEmpty, NSchange} from '../lib/ep.js';
import { arrayMove } from 'react-sortable-hoc';

export default function main(state = {questions:[]}, action) {
  switch (action.type) {
	 
   case 'SETQUIZ':
     return {...state,questions:action.questions};


		case 'CHANGEQUESTION':

      //Change one of the values of a question
      for (var i in  state.questions) {
        if (state.questions[i].Question.id != action.qid) continue;
        i = parseInt(i);

        //We found the question.
        var q = {Question:NSchange(state.questions[i].Question,action.k,action.v,true),Answer:state.questions[i].Answer};

        return {...state,questions:state.questions.slice(0,i).concat(q).concat(state.questions.slice(i+1))}
      }

    case 'ASSIGNTOSTAGE':
      let changed = [];

      if (action.question != undefined) {
        const q = state.questions.find(q=>q.Question.id==action.question.id);
        if (q == null) 
          state.questions = [...state.questions,{Question:action.question,'Answer':[]}];
      }

      for (var i in  state.questions) {
        i = parseInt(i);

        if (state.questions[i].Question.stage != null){
          changed.push(state.questions[i]);
          continue;
        } 
        //We found the question.
        changed.push({Question:NSchange(state.questions[i].Question,'stage',action.stage,true),Answer:state.questions[i].Answer});
      }
      return {...state,questions:[...changed]}

    case 'DELETEQUESTION':
       for (var i in  state.questions) {
        if (state.questions[i].Question.id != action.qid) continue;
        i = parseInt(i);
        return {...state,questions:state.questions.slice(0,i).concat(state.questions.slice(i+1))}
      }
    
    case 'DELETEBYSTAGE':
      return {
        ...state,
        questions: state.questions.filter(q=>q.Question.stage!=action.stage_id)
      }

    case 'ADDQUESTION':
      if (action.questions.Question) action.questions = [action.questions];
      return {...state,questions:[...state.questions,...action.questions]};


    case 'ADDANSWERS':
      for (var i in  state.questions) {
        if (state.questions[i].Question.id != action.qid) continue;

         var q = {
            Question:state.questions[i].Question,
            Answer: state.questions[i].Answer.concat(action.answers)
        };

        state.questions[i] = q;
        return {...state,questions:state.questions.slice()}
      }
      return state;


    case 'DELETEANSWER':
      for (var i in  state.questions) {
        if (state.questions[i].Question.id != action.qid) continue;

        for (var j in state.questions[i].Answer) {

          if (state.questions[i].Answer[j].id != action.aid) continue;

          j = parseInt(j);
          i = parseInt(i);
         
          var q = {
            Question:state.questions[i].Question,
            Answer: 
              state.questions[i].Answer.slice(0,j).concat(state.questions[i].Answer.slice(parseInt(j)+1))};

            if (q.Question.config.min_answers != undefined && q.Question.config.min_answers > q.Answer.length) {
              q.Question.config.min_answers = q.Answer.length;
            }

            var f = {...state,questions:state.questions.slice(0,i).concat(q).concat(state.questions.slice(i+1))}
          return f;
        }
      }
      return state;

    case 'SORTANSWER':

      return {
        ...state,
        questions:state.questions.map(q => {
          if (q.Question.id != action.qid) return q;

          var ans = arrayMove(q.Answer, action.oldIndex, action.newIndex);
        
          for(var j in ans) {
            ans[j].pos = j;
          }
          
          return {
            ...q,
            Answer:ans
          }
        })
      }
      break;

    case 'SORTQUESTION':
      const by_stage = isNotEmpty(action,'stage');

      var questions_to_sort = by_stage?state.questions.filter(q=>q.Question.stage==action.stage):state.questions;
      var qs = arrayMove(questions_to_sort, action.oldIndex, action.newIndex);
    
      for(var j in qs) {
        qs[j].Question.pos = j;
      }
      var f = qs.slice(0);

      if (by_stage) {
        f = state.questions.filter(q=>q.Question.stage!=action.stage).concat(f);
      }
      
      return {...state,questions:f};
     
      break;

    case 'CHANGEANSWER':

      //Change one of the values of a question
      for (var i in  state.questions) {
        if (state.questions[i].Question.id != action.qid) continue;
        //We found the question.
        
        for (var j in state.questions[i].Answer) {

          if (state.questions[i].Answer[j].id != action.aid) continue;
          i = parseInt(i);
          var q = {
            Question:state.questions[i].Question,
            Answer: 
              state.questions[i].Answer.slice(0,j).concat(
                NSchange(state.questions[i].Answer[j],action.k,action.v,true))
              .concat(state.questions[i].Answer.slice(parseInt(j)+1))};

          var f = {...state,questions:state.questions.slice(0,i).concat(q).concat(state.questions.slice(i+1))}
          return f;
        }
      }



	  default:
			return state;
	}
}


